import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Icon from "@components/icon";

import styles from "../Burger.scss";

const cx = classnames.bind(styles);

const DropdownHeader = ({ onClick, label }) => (
  <div className={cx("dropdown-header")}>
    <button onClick={onClick} className={cx("back-button")}>
      <Icon
        name="ic_arrow-left-out"
        fill="var(--glz-color-neutral-tone-5)"
        size="s"
      />
      <span className={cx("back-label")}>{label}</span>
    </button>
  </div>
);

DropdownHeader.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
};

export default DropdownHeader;
